
import Vuex from 'vuex'

export const store =  new Vuex.Store({
	state: {
		mainView: 'quote-main',
		mvProp1: '',
		mvProp2: '',
		mvProp3: [],

		quoteList: [],
		quoteComp: '0',



	},

	mutations: {
		setMainView(state, payload) { state.mainView = payload.name; state.mvProp1 = payload.prop1; state.mvProp2 = payload.prop2; state.mvProp3 = payload.prop3 },

		setQuotes(state, payload) { state.quoteList = payload.info; state.quoteComp = payload.info1; },
		setQuotesComp(state, payload) { state.quoteComp = payload.info1; },






		

  	},

	actions: {
		getMainView(context, payload) { context.commit("setMainView", { name: payload.name, prop1: payload.prop1, prop2: payload.prop2, prop3: payload.prop3 })  },
		getAllQuotes(context, payload) {
			context.commit("setQuotesComp", { info1: '0' }) 
			axios.get('/utility/admin/quote/getallquotes')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setQuotes", { info: b, info1: '1' }) 
	          	});
		},
		
		
	    
	}

})